import React, { useState, useRef } from 'react';
import './App.css';
import ToolList from './ToolList';  // 工具列表组件
import ToolPanel from './ToolPanel';  // 工具参数面板组件
import DrawingArea from './DrawingArea';  // 绘图区域组件

function Home() {
  // #tool01 state
  const [circleCount, setCircleCount] = useState(3);
  const [minRadius, setMinRadius] = useState(50);
  const [spacing, setSpacing] = useState(30);
  const [baseFontSize, setBaseFontSize] = useState(40);
  const [fontSizeDecreaseFactor, setFontSizeDecreaseFactor] = useState(0);
  const [fontWeight, setFontWeight] = useState(400);
  const [colors, setColors] = useState(['#ff5454', '#27ff8c', '#b75fff']);
  const [svgWidth, setSvgWidth] = useState(1660);
  const [svgHeight, setSvgHeight] = useState(1070);

  // #tool02 state (DrawTool)
  const drawToolRef = useRef();

  // #tool03 state (FillEdges)
  const [fillEdgesImageWidth, setFillEdgesImageWidth] = useState(800);
  const [fillEdgesImageHeight, setFillEdgesImageHeight] = useState(1000);
  const [fillEdgesFillColor, setFillEdgesFillColor] = useState('#000000');
  const [fillEdgesStrokeColor, setFillEdgesStrokeColor] = useState("#0000ff");
  const [fillEdgesStrokeWidth, setFillEdgesStrokeWidth] = useState(2);
  const [fillEdgesBackgroundColor, setFillEdgesBackgroundColor] = useState("#000000");
  const [fillEdgesBackgroundThreshold, setFillEdgesBackgroundThreshold] = useState(245);
  const [aColor, setAColor] = useState("#0000ff");
  const [aAngle, setAAngle] = useState(45);
  const [aThickness, setAThickness] = useState(2);
  const [aSpacing, setASpacing] = useState(20);
  const [bColor, setBColor] = useState("#00ff00");
  const [bAngle, setBAngle] = useState(69);
  const [bThickness, setBThickness] = useState(2);
  const [bSpacing, setBSpacing] = useState(20);

  // #tool04 state (B&W Halftone)
  const [halftoneImage, setHalftoneImage] = useState(null);
  const [halftoneDotSize, setHalftoneDotSize] = useState(3);
  const [brightnessThreshold, setBrightnessThreshold] = useState(128);
  const [dotSpacing, setDotSpacing] = useState(10);
  const [dotColor, setDotColor] = useState('#000000');
  const [scale, setScale] = useState(1);

  // 创建 fillEdgesRef
  const fillEdgesRef = useRef();  // This is the missing reference

  // 工具选择事件
  const [selectedTool, setSelectedTool] = useState('tool01');

  // 工具列表
  const tools = [
    { id: 'tool01', label: '-- Concentric Circles' },
    { id: 'tool02', label: '-- Poster' },
    { id: 'tool03', label: '-- Fill Edges' },
    { id: 'tool04', label: '-- B&W Halftone' }  // 添加 Tool04 (B&W Halftone) 到工具列表
  ];

  // 工具选择回调函数
  const handleToolSelect = (toolId) => {
    setSelectedTool(toolId);
  };

  // 更新工具参数的回调函数
  const handleToolUpdate = (key, value) => {
    switch (key) {
      // Tool01
      case 'circleCount':
        setCircleCount(value);
        break;
      case 'minRadius':
        setMinRadius(value);
        break;
      case 'spacing':
        setSpacing(value);
        break;
      case 'baseFontSize':
        setBaseFontSize(value);
        break;
      case 'fontSizeDecreaseFactor':
        setFontSizeDecreaseFactor(value);
        break;
      case 'fontWeight':
        setFontWeight(value);
        break;
      case 'colors':
        setColors(value);
        break;
      case 'svgWidth':
        setSvgWidth(value);
        break;
      case 'svgHeight':
        setSvgHeight(value);
        break;

      // Tool02 (DrawTool)
      case 'drawToolWidth':
        setSvgWidth(value);
        break;

      // Tool03 (FillEdges)
      case 'fillEdgesImageWidth':
        setFillEdgesImageWidth(value);
        break;
      case 'fillEdgesImageHeight':
        setFillEdgesImageHeight(value);
        break;
      case 'fillEdgesFillColor':
        setFillEdgesFillColor(value);
        break;
      case 'fillEdgesStrokeColor':
        setFillEdgesStrokeColor(value);
        break;
      case 'fillEdgesStrokeWidth':
        setFillEdgesStrokeWidth(value);
        break;
      case 'fillEdgesBackgroundColor':
        setFillEdgesBackgroundColor(value);
        break;
      case 'fillEdgesBackgroundThreshold':
        setFillEdgesBackgroundThreshold(value);
        break;
      case 'aColor':
        setAColor(value);
        break;
      case 'aAngle':
        setAAngle(value);
        break;
      case 'aThickness':
        setAThickness(value);
        break;
      case 'aSpacing':
        setASpacing(value);
        break;
      case 'bColor':
        setBColor(value);
        break;
      case 'bAngle':
        setBAngle(value);
        break;
      case 'bThickness':
        setBThickness(value);
        break;
      case 'bSpacing':
        setBSpacing(value);
        break;

      // Tool04 (B&W Halftone)
      case 'halftoneImage':
        setHalftoneImage(value);
        break;
      case 'halftoneDotSize':
        setHalftoneDotSize(value);
        break;
      case 'brightnessThreshold':
        setBrightnessThreshold(value);
        break;
      case 'dotSpacing':
        setDotSpacing(value);
        break;
      case 'dotColor':
        setDotColor(value);
        break;
      case 'scale':
        setScale(value);
        break;
        
      default:
        break;
    }
  };

  // 用于清除绘制路径的方法
  const clearPaths = () => {
    if (drawToolRef.current && typeof drawToolRef.current.clearPaths === 'function') {
      drawToolRef.current.clearPaths();
    } else {
      console.warn("DrawTool 中的 clearPaths 方法未实现");
    }
  };

  // 用于下载 DrawTool 绘图的 SVG 文件
  const downloadDrawToolSVG = () => {
    if (drawToolRef.current && typeof drawToolRef.current.downloadSVG === 'function') {
      drawToolRef.current.downloadSVG();
    } else {
      console.log('DrawingTool ref:', drawToolRef.current);  // Should log the DrawTool component
      console.warn("DrawTool 中的 downloadSVG 方法未实现");
    }
  };

  // 用于下载 ConcentricCircles 绘图的 SVG 文件
  const downloadConcentricSVG = () => {
    const svgElement = document.getElementById('concentric-svg');
    if (!svgElement) return;
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'concentric-circles.svg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 用于下载 FillEdges 绘图的 SVG 文件
  const downloadFillEdgesSVG = () => {
    if (fillEdgesRef.current && typeof fillEdgesRef.current.downloadSVG === 'function') {
      fillEdgesRef.current.downloadSVG();
    } else {
      console.warn("FillEdges downloadSVG function not available.");
    }
  };

  // 用于下载 Tool04 (B&W Halftone) 绘图的 SVG 文件
  const downloadHalftoneSVG = () => {
    // 在 Tool04 组件中实现下载 SVG 功能
    console.log("Download Halftone SVG function not yet implemented.");
  };

  return (
    <div className="app-container">
      <div className="gui-layout">
        {/* 左侧工具列表 */}
        <ToolList tools={tools} selectedTool={selectedTool} onToolSelect={handleToolSelect} />

        {/* 工具参数面板 */}
        <ToolPanel
          selectedTool={selectedTool}
          toolProps={{
            circleCount, minRadius, spacing, baseFontSize, fontSizeDecreaseFactor,
            fontWeight, colors, svgWidth, svgHeight,
            fillEdgesImageWidth, fillEdgesImageHeight, fillEdgesFillColor, fillEdgesStrokeColor,
            fillEdgesStrokeWidth, fillEdgesBackgroundColor, fillEdgesBackgroundThreshold,
            aColor, aAngle, aThickness, aSpacing, bColor, bAngle, bThickness, bSpacing,
            halftoneImage, halftoneDotSize, brightnessThreshold, dotSpacing, dotColor, scale
          }}
          onUpdate={handleToolUpdate}
          clearPaths={clearPaths}  // Tool02 清除路径功能
          downloadSVGTool01={downloadConcentricSVG}  // Tool01 下载功能
          downloadSVGTool02={downloadDrawToolSVG}  // Tool02 下载功能
          downloadSVGTool03={downloadFillEdgesSVG}  // Tool03 下载功能
          downloadSVGTool04={downloadHalftoneSVG}  // Tool04 下载功能
        />

        {/* 绘图区域 */}
        <DrawingArea
          selectedTool={selectedTool}
          toolProps={{
            circleCount, minRadius, spacing, baseFontSize, fontSizeDecreaseFactor,
            fontWeight, colors, svgWidth, svgHeight,
            fillEdgesImageWidth, fillEdgesImageHeight, fillEdgesFillColor, fillEdgesStrokeColor,
            fillEdgesStrokeWidth, fillEdgesBackgroundColor, fillEdgesBackgroundThreshold,
            aColor, aAngle, aThickness, aSpacing, bColor, bAngle, bThickness, bSpacing,
            halftoneImage, halftoneDotSize, brightnessThreshold, dotSpacing, dotColor, scale
          }}
          clearPaths={clearPaths}  // 传递clearPaths方法
          downloadDrawToolSVG={downloadDrawToolSVG}  // 传递downloadDrawToolSVG方法
          downloadConcentricSVG={downloadConcentricSVG}  // 传递downloadConcentricSVG方法
          downloadFillEdgesSVG={downloadFillEdgesSVG}  // 传递downloadFillEdgesSVG方法
          downloadHalftoneSVG={downloadHalftoneSVG}  // 传递downloadHalftoneSVG方法
          fillEdgesRef={fillEdgesRef}  // 传递fillEdgesRef给子组件
          drawToolRef={drawToolRef}  // Ensure ref is passed for DrawTool
        />
      </div>
    </div>
  );
}

export default Home;
